import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { communicationV1EmailsDetailsRetrieve } from '../../__generated__/oazapfts-client';
import type { MeetingCommunication } from '../../entities/communication';
import { meetingCommunicationMapper } from '../../mappers/communication.mapper';

export namespace GetOneMeetingCommunication {
  export const key = (input: Input) => [
    'communication',
    'get-one-meeting-communication',
    input.id,
  ];

  export type Input = { id: string };
  export type Output = MeetingCommunication;

  export function useQuery(input: Input) {
    const auth = useAuth();
    const me = useMe();

    return rq.useQuery<Output>({
      queryKey: key(input),
      async queryFn() {
        const accessToken = await auth.getAccessToken();
        const result = await communicationV1EmailsDetailsRetrieve(
          {
            uuid: input.id,
            xUserName: me.displayName,
            xUserEmail: me.email,
          },
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (result.status !== 200) {
          throw new Error('Fail to fetch communications');
        }

        return meetingCommunicationMapper(result.data);
      },
    });
  }
}
